import { LegalForm } from './legal-form.interface';
import { LegalFormService } from './legal-form.service';

const service = new LegalFormService();

export interface LegalFormState {
   legalForms: Array<LegalForm>;
}

const state: LegalFormState = {
   legalForms: [],
};

const getters = {
   legalForms(state: any) {
      return state.all;
   },
};

const mutations = {
   SET_LEGAL_FORMS(state: any, legalForms: Array<LegalForm>) {
      state.legalForms = legalForms;
   },
};

const actions = {
   async getLegalForms(context: any) {
      return await service.getLegalForms().then((response) => {
         context.commit('SET_LEGAL_FORMS', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
